export var PasswordResetError;
(function (PasswordResetError) {
    PasswordResetError["notFound"] = "password-reset-not-found";
})(PasswordResetError || (PasswordResetError = {}));
var PasswordResetRequest = /** @class */ (function () {
    function PasswordResetRequest(token, userId) {
        this.isAuthenticated = false;
        this.knownErrorCodes = Object.values(PasswordResetError);
        this.path = "authentication/password/reset/".concat(encodeURIComponent(token), "?user=").concat(encodeURIComponent(userId));
    }
    return PasswordResetRequest;
}());
export { PasswordResetRequest };
